export const load = () => ({
	h1: 'Careers at Indow',
	title: 'Careers at Indow',
	description:
		"Interested in continuous personal & professional growth, saving the environment, and historic preservation? Start your career with Indow, we're hiring!",
	showTitle: true,
});
